<template>
  <div>
    <h1>CONTACT</h1>
    <div class="content-wrapper">
      <div class="content-box">
        <img src="../assets/img/contact.jpg" alt="forrest" class="img">
      </div>
      <div class="content-box">
        <p class="form-text">mir schwätze lëtzebuergesch, français, deutsch, english</p>
        <form action="#" method="POST" @submit.prevent="sendMail">
          <!-- <div class="form-group">
            <label for="name">name:</label>
            <input id="name" class="textfield" v-model="name">
            <div class="form-error"></div>
          </div> -->
          <!-- <div class="form-group">
            <label for="e-mail">e-mail:</label>
            <input id="e-mail" class="textfield" v-model="email">
            <div class="form-error"></div>
          </div>
          <div class="form-group">
            <label for="address">address:</label>
            <input id="address" class="textfield" v-model="address">
            <div class="form-error"></div>
          </div> -->
          <div class="form-group">
            <label for="subject">subject:</label>
            <input id="subject" class="textfield" v-model="subject">
            <div class="form-error"></div>
          </div>
          <div class="form-group">
            <label for="text">text:</label>
            <textarea id="text" class="textfield" v-model="text" rows="10" />
            <div class="form-error"></div>
          </div>
          <div class="btn-box">
            <!-- <div class="g-recaptcha" data-sitekey="6LfoCaIUAAAAAMcSrXiGIT_NSZMJaXUdNxsJrVhG"></div> -->
            <input type="submit" value="send mail" class="submit-btn">
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data () {
    return {
      // name: '',
      // email: '',
      // address: '',
      subject: '',
      text: '',
      message: ''
    }
  },
  methods: {
    sendMail () {
      // let address
      // this.address !== '' ? address = '\r\n' + 'address: ' + this.address : address = ''
      // this.message = this.text + '\r\n' + 'name: ' + this.name + '\r\n' + 'email: ' + this.email + address
      const mail = 'sonjaroef@skynet.be?subject=' + this.subject + '&body=' + encodeURIComponent(this.text)
      window.location.href = 'mailto:' + mail
    }
  }
}
</script>

<style lang='scss' scoped>
.content-wrapper {
  display: flex;
  .content-box {
    width: 50%;
    img {
      width: 100%;
    }
    .g-recaptcha {
      margin-bottom: 1.25rem;
    }
  }
  .content-box:first-child {
    padding-right: 50px;
  }
}
.form-group {
    margin-bottom: 1.25rem;
    display: flex;
}
.form-text {
  font-weight: 600;
  font-size: 1.2em;
}

label {
  width: 110px;
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 1.3em;
}
.textfield {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-width: 1px;
    border-color: rgba(0,0,0,.5);
    width: 100%;
    padding: .75rem;
    color: #000;
    line-height: 1.25;
}
.btn-box {
  display: flex;
  flex-flow: column;
  align-items: flex-end;
}
.submit-btn {
    color: #fff;
    font-weight: 700;
    padding-left: 1rem;
    padding-right: 1rem;
    border-radius: .25rem;
    height: 50px;
    background-color: #835e0f;
    width: 150px;
    &:hover {
      background-color: rgba(131, 94, 15, 0.85);
      cursor: pointer;
    }
}
@media screen and (max-width: 1300px) {
  .content-wrapper {
    display: flex;
    flex-flow: column;
    .content-box {
      width: 100%;
    }
    .content-box:first-child {
      padding-right: 0;
      margin-bottom: 25px;
    }
  }
}

</style>
